import { http } from '@frontend/fetch';

type Connection = {
  locationID: string;
  sourceID: string;
  connectionID: string;
  clientVersion: string;
};

type SyncAppConnectionResponse = {
  data: { connections: Connection[] };
};

const syncAppConnectionsUrl = 'support/v1/syncapp/connections';

export const getSyncAppConnection = (sourceId: string) =>
  http.get<SyncAppConnectionResponse>(syncAppConnectionsUrl, {
    params: { sourceID: sourceId },
  });
